<template>
    <div ref="video" class="video" v-show="show">
        <div class="close" @click="hide"></div>
        <video width="100%" height="100%" id="videoPlay"
        class="video-js vjs-default-skin vjs-big-play-centered"
               autoplay="autoplay" 
               muted
               preload="auto"
               src="./../assets/jksp.mp4"
               ref="video"
              >
        </video>
    </div>
</template>

<script>
    import Hls from 'hls.js';
    export default {
        name: "Video",
        data(){
            return{
                hls:'',
                show:false,
                a:['smgd0207', 'smgd0201', 'smgd0208', 'smgd0202', 'smgd0402', 'smgd0404', 'smgd0406', 'smgd0105', 'smgd0103', 'smgd0102', 'smgd0108', 'smgd0606', 'smgd1401', 'smgd1201', 'smgd1203', 'smgd1102', 'smgd1302', 'smgd1105', 'smgd1104', 'smgd1305', 'smgd1304', 'smgd2201', 'smgd2202', 'smgd3302', 'smgdf1', 'smgdf4', 'smgdf6', 'smgdf9', 'smgdf10', 'smgdf14', 'smgdf16', 'smgdf17', 'smgdf18']
            }
        },
        mounted() {

            window.changeShow1 = this.changeShow;
        },
        methods:{
            // paly(src) {
            //     // eslint-disable-next-line @typescript-eslint/no-this-alias
            //     var that = this;
            //     //使用videoId请求播放的路径
            //     //获得要播放的video引用，相当于documentById.getElementById('');
            //     var video = that.$refs.video;
            //     var videoSrc = src;
            //     //是否支持hls,hls.js源码中封装好的
            //     if (Hls.isSupported()) {
            //         that.hls = new Hls();

            //         //传视频路径
            //         that.hls.loadSource(videoSrc);
            //         //传元素索引
            //         that.hls.attachMedia(video);
            //         that.hls.on(Hls.Events.MANIFEST_PARSED, function () {

            //             video.play();
            //         });
            //     }
            // },
            //视频关闭
            // videoPause() {
            //     if (this.hls) {
            //         console.log("销毁")
            //         this.$refs.video.pause();
            //         //销毁视频流通道
            //         this.hls.destroy();
            //         this.hls = null;
            //     }
            // },
            hide(){
                this.show = false;
               
            },
            
            changeShow(){
              this.flage = true
              this.show = true;
                this.$refs.video.style.opacity = 1;
            },
        }
    }
</script>

<style scoped>
    .video{
        width: 628px;
        height: 320px;
        border: 4px solid #3a9792;
        background: rgba(0,0,0,1);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 1;
    }
    .close{
        position: absolute;
        background: url("./../assets/close.png") no-repeat;
        background-size: 100% 100%;
        width: 25px;
        height: 25px;
        z-index: 999;
        top: 10px;
        right: 10px;
        cursor: pointer;

    }
</style>